import C3 from "../img/c3.png";
import I1 from "../img/i1.png";
export const cardData = [
  {
    id: 1,
    name: "Ice-cream",
    desc: "Chocolate & Vanilla",
    price: 5.25,
    imgSrc: I1,
  },
  {
    id: 2,
    name: "Package",
    desc: "Chicken,Fish,Vorta",
    price: 5.0,
    imgSrc: C3,
  },
];
